<script lang="ts">
    let {currentPage, numPages, onPageChange} = $props();
</script>
<ul class="pagination pagination-sm">
  <li class:disabled={currentPage === 1}><button type="button" onclick={(e) => { onPageChange(1); }}>Pierwsza</button></li>
  <li class:disabled={currentPage === 1}><button type="button" onclick={(e) => { onPageChange(Math.max(1, currentPage - 1)); }}>Poprzednia</button></li>
  <li class="disabled"><button type="button" onclick={() => {}}>{currentPage}</button></li>
  <li class:disabled={currentPage === numPages}><button type="button" onclick={(e) => { onPageChange(Math.min(numPages, currentPage + 1)); }}>Następna</button></li>
  <li class:disabled={currentPage === numPages}><button type="button" onclick={(e) => { onPageChange(numPages); }}>Ostatnia</button></li>
</ul>
